export default __webpack_public_path__ + "img/blue_funeral_icon.cf0e767ffb0daffe2352f5a24c7b83b5.svg";